import React from 'react';
import { useGetLegalClientLogsByLegalClient } from '../../hooks/reactQuerys/LegalClientQueries';
import { CustomCircularProgress } from '../../generic/CustomCircularProgress';
import { Box, Button, Grid, Typography } from '@mui/material';

interface IProps {
  idLegalClient: number;
}

export const LogTab: React.FC<IProps> = ({ idLegalClient }) => {
  const { legalClientLogs, isLoadingLegalClientLogs, refetchLegalClientLogs } =
    useGetLegalClientLogsByLegalClient(idLegalClient);

  if (isLoadingLegalClientLogs) {
    return <CustomCircularProgress />;
  }

  if (!legalClientLogs) {
    return (
      <Box
        sx={{
          minHeight: '50vh',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          gap: 1,
        }}
      >
        <Typography variant='h6'>
          Fehler beim Laden der Daten. Bitte versuchen Sie es erneut.
        </Typography>
        <Button variant='contained' onClick={() => refetchLegalClientLogs()}>
          Erneut versuchen
        </Button>
      </Box>
    );
  }

  return (
    <>
      <Typography variant='h5'>Log</Typography>
      <Grid sx={{ mt: 2 }} container spacing={1}>
        {legalClientLogs.map(log => (
          <React.Fragment key={log.Timestamp}>
            <Grid item xs={4} sm={2}>
              {new Date(String(log.Timestamp)).toLocaleString('de-DE')}
            </Grid>
            <Grid item xs={8} sm={10}>
              {log.Log}
            </Grid>
          </React.Fragment>
        ))}
      </Grid>
    </>
  );
};
